import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { computed } from "vue";
import MaterialIcon from "@/shared/components/utils/MaterialIcon.vue";
import InlineSpinner from "@/shared/components/utils/InlineSpinner.vue";

interface PropsInterface {
  icon?: string;
  outline?: boolean;
  ghost?: boolean;
  color?: string; // primary, danger, ...
  disabled?: boolean;
  small?: boolean;
  link?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleButton',
  props: {
    icon: null,
    outline: { type: Boolean },
    ghost: { type: Boolean },
    color: null,
    disabled: { type: Boolean },
    small: { type: Boolean },
    link: { type: Boolean },
    loading: { type: Boolean },
    fullWidth: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props as {
  icon?: string;
  outline?: boolean;
  ghost?: boolean;
  color?: string; // primary, danger, ...
  disabled?: boolean;
  small?: boolean;
  link?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
};



const btnCls = computed(() => {
  if (!props.color) return "";
  const baseName = props.link ? "link" : "btn";
  return props.outline
    ? `${baseName}-outline-${props.color}`
    : props.ghost
    ? `${baseName}-ghost-${props.color}`
    : `${baseName}-${props.color}`;
});

const disabledCls = computed(() => (props.disabled ? "disabled" : ""));
const sizeCls = computed(() => (props.small ? "btn-sm" : ""));
const linkCls = computed(() => (props.link ? "btn-link" : ""));
const widthCls = computed(() => (props.fullWidth ? "w-100" : ""));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", [_unref(btnCls), _unref(disabledCls), _unref(sizeCls), _unref(linkCls), _unref(widthCls)]]),
    disabled: props.disabled,
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(InlineSpinner, {
          key: 0,
          class: "me-2",
          small: ""
        }))
      : _createCommentVNode("", true),
    (props.icon)
      ? (_openBlock(), _createBlock(MaterialIcon, {
          key: 1,
          name: props.icon,
          small: props.small
        }, null, 8, ["name", "small"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})